export enum AuthStatus {
	UNKNOWN = 'UNKNOWN',
	AUTHENTICATION_REQUIRED = 'REQUIRE_AUTHENTICATION',
	LOGGED_OUT = 'LOGGED_OUT',
	AUTHENTICATED = 'AUTHENTICATED',
}
